import swal from 'sweetalert'

export const continueWithSave = async (allowOverwrite, lastKnownExampleMap, fetchExampleMap) => {
  const result = {
    continueWithSave: false,
    reload: false
  }

  const exampleMap = await fetchExampleMap()
  if (exampleMap === null) {
    result.continueWithSave = true
    return result
  }

  if (JSON.stringify(exampleMap) !== lastKnownExampleMap) {
    window.amplitude.getInstance().logEvent('em_contention')

    const buttons = {
      reload: {
        text: 'Reload',
        value: true
      }
    }
    if (allowOverwrite) {
      buttons.cancel = 'Cancel'
    }
    await swal({
      title: 'Example Map has been saved since you last loaded it',
      text: 'Click to reload',
      icon: 'warning',
      buttons: buttons
    }).then(shouldReload => {
      if (shouldReload) {
        result.reload = true
      }
    })
  } else {
    result.continueWithSave = true
  }

  return result
}
